export default "__VITE_ASSET__WJV0huO$__"